import { render } from "./BulkAccountModal.vue?vue&type=template&id=5aa8b512"
import script from "./BulkAccountModal.vue?vue&type=script&lang=js"
export * from "./BulkAccountModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__